module.exports = __webpack_public_path__ + "media/quest-complete.83c3e035.wav";